<template>
  <b-container fluid class="asset-relation-report">
    <b-row>
      <b-col>
        <reports-filter
          is-company-field-required
          is-installation-field-required
          is-asset-field-required
          is-type-field-required
          has-type-field
          :filter.sync="reportsFilter"
          :filter-objects.sync="reportsFilterObjects"
        />
      </b-col>
    </b-row>
    <b-row class="mt-5 mb-3">
      <b-col>
        <additional-fields
          :tabs-to-show="assetTypesByFilter"
          @fields-selected="setAdditionalFields"
        />
      </b-col>
      <b-col align-h="end">
        <div class="asset-relation-report__buttons">
          <b-button
            variant="outline-green"
            :disabled="disableExport"
            @click="generateReport(exportXlsx)"
          >
            <s-loader
              v-if="loading"
              class="asset-relation-report__xlsx-loading"
            />
            <i v-else
              aria-hidden="true"
              class="fas fa-file-excel mr-1"
            />
            <span>{{ $t('general.export-xlsx') }}</span>
          </b-button>
          <b-button
            class="ml-1"
            variant="primary"
            @click="generateReport(viewReport)"
          >
            {{ $t('reports.filters.view-report') }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ReportsFilter from '@/components/ReportsFilter';
import AssetRelationService from '@/domain/services/generalPanel/reports/assetsRelation/assetList';
import LoadingMixin from '@/services/loadingMixin';
import AdditionalFields from '@/domain/components/generalPanel/reports/additionalFields/AdditionalFields';
import StorageManager from '@/services/sessionStorageManager';
import GenerateReportMixin from '@/domain/mixins/generalPanel/reports/generateReportMixin';

export default {
  name: 'AssetRelationTab',
  components: {
    ReportsFilter,
    AdditionalFields,
  },
  mixins: [LoadingMixin, GenerateReportMixin],
  data: () => ({
    reportsFilter: {},
    reportsFilterObjects: {},
    requiredFields: [
      'companiesIds',
      'installationsIds',
      'assetsIds',
      'assetTypes',
    ],
    additionalFieldsModalVisibility: false,
  }),
  computed: {
    modalVisibility: {
      get() {
        return this.additionalFieldsModalVisibility;
      },
      set(value) {
        this.additionalFieldsModalVisibility = value;
      },
    },
    assetTypesByFilter() {
      const assetTypes = this.reportsFilterObjects.assetTypes || [];
      return assetTypes.map(asset => asset.key);
    },
    disableExport() {
      return this.loading;
    },
  },
  methods: {
    exportXlsx() {
      this.startLoading();
      AssetRelationService.exportExcel(this.reportsFilter)
        .then(() => this.$pushAlert({ code: 'MS011' }))
        .finally(() => { this.endLoading(); });
    },
    viewReport() {
      const stringifyFilter = JSON.stringify(this.reportsFilter);
      const storageKey = StorageManager.setItemWithId(
        'assetsRelationFilter',
        stringifyFilter,
      );
      const routeData = this.$router.resolve({
        name: 'clean-view.assets-relation.view-report',
        query: {
          filter: storageKey,
        },
      });
      window.open(routeData.href, '_blank');
    },
    getFieldLabel(field) {
      const fields = {
        companiesIds: this.$t('entities.company'),
        installationsIds: this.$t('entities.installation'),
        assetTypes: this.$t('entities.type'),
        assetsIds: this.$t('entities.asset'),
      };
      return fields[field];
    },
    setAdditionalFields(value) {
      this.reportsFilter.additionalFields = value;
    },
  },
};
</script>

<style lang="sass" scoped>
.asset-relation-report
  &__field-label
    font-weight: 600
  &__buttons
    text-align: right
  &__xlsx-loading
    display: inline-flex
</style>
